import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const TriangleShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 374.2 374.1",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 374.1h374.2L187.1 0 0 374.1z"
    })
  });
};

export { TriangleShape };
//# sourceMappingURL=TriangleShape.js.map
